export const complaintsList = [
  { label: 'Activation/Provision', value: 'Activation/Provision' },
  { label: 'Billing/Charges', value: 'Billing/Charges' },
  { label: 'Customer Experience', value: 'Customer Experience' },
  { label: 'Faults', value: 'Faults' },
  { label: "I'm not a customer", value: "I'm not a customer" },
  { label: 'My Contract/Package', value: 'My Contract/Package' },
  { label: 'Privacy and Security', value: 'Privacy and Security' },
];

const billingChargesList = [
  { label: 'Equipment Return', value: 'Equipment Return' },
  {
    label: 'I am unhappy about the arrears process',
    value: 'I am unhappy about the arrears process',
  },
  {
    label: "I don't understand or agree with charges on my bill",
    value: "I don't understand or agree with charges on my bill",
  },
  {
    label: 'I dispute the early termination fee',
    value: 'I dispute the early termination fee',
  },
  { label: "I haven't received my bill", value: "I haven't received my bill" },
  {
    label: "There's a problem with my payment",
    value: "There's a problem with my payment",
  },
  { label: 'Other', value: 'Other' },
];

const activationProvisionList = [
  {
    label: 'Delay in installing my services',
    value: 'Delay in installing my services',
  },
  {
    label: 'Dissatisfied with tech visit',
    value: 'Dissatisfied with tech visit',
  },
  { label: 'Failed to install', value: 'Failed to install' },
  { label: 'Missed appointment', value: 'Missed appointment' },
  { label: "My delivery hasn't arrived", value: "My delivery hasn't arrived" },
  {
    label: "My package isn't as described",
    value: "My package isn't as described",
  },
  {
    label: 'Unable to place an order online',
    value: 'Unable to place an order online',
  },
  { label: 'Other', value: 'Other' },
];

const customerExperienceList = [
  { label: 'Bereavement Issue', value: 'Bereavement Issue' },
  { label: 'Complaint Handling', value: 'Complaint Handling' },
  { label: 'Failed Call Back', value: 'Failed Call Back' },
  { label: 'Long Wait times', value: 'Long Wait times' },
  { label: 'Staff Conduct', value: 'Staff Conduct' },
  { label: 'Other', value: 'Other' },
];

const faultsList = [
  { label: 'Delay in fixing my problem', value: 'Delay in fixing my problem' },
  {
    label: 'I have full loss of service',
    value: 'I have full loss of service',
  },
  { label: "I'm missing a channel", value: "I'm missing a channel" },
  {
    label: 'Issues with Virgin Media Apps',
    value: 'Issues with Virgin Media Apps',
  },
  {
    label: "My on demand/catch up service isn't working",
    value: "My on demand/catch up service isn't working",
  },
  {
    label: "My set top box isn't working",
    value: "My set top box isn't working",
  },
  {
    label: 'The picture quality is poor',
    value: 'The picture quality is poor',
  },
  {
    label: 'Unhappy with planned maintenance work',
    value: 'Unhappy with planned maintenance work',
  },
  { label: 'Other', value: 'Other' },
  { label: 'Connection Problems', value: 'Connection Problems' },
  { label: 'Speed problems', value: 'Speed problems' },
  { label: 'Trouble accessing my email', value: 'Trouble accessing my email' },
  { label: 'Call Feature Issue', value: 'Call Feature Issue' },
  {
    label: "I'm receiving incorrect calls",
    value: "I'm receiving incorrect calls",
  },
  {
    label: "I'm unable to make/receive a call",
    value: "I'm unable to make/receive a call",
  },
  { label: 'My line noisey', value: 'My line noisey' },
  { label: 'Nuisance Calls', value: 'Nuisance Calls' },
  { label: 'Trouble Porting my number', value: 'Trouble Porting my number' },
  {
    label: 'I have issues with call quality',
    value: 'I have issues with call quality',
  },
  { label: 'I have no signal', value: 'I have no signal' },
  {
    label: 'Issues with my roaming service',
    value: 'Issues with my roaming service',
  },
  { label: 'I have a Handset Fault', value: 'I have a Handset Fault' },
  {
    label: 'Issues with mobile broadband',
    value: 'Issues with mobile broadband',
  },
];

const notCustomerList = [
  { label: 'Bereavement Issue', value: 'Bereavement Issue' },
  { label: 'Cabinet Maintenance', value: 'Cabinet Maintenance' },
  { label: 'Damage', value: 'Damage' },
  { label: 'Equipment Location', value: 'Equipment Location' },
  { label: 'Fraud', value: 'Fraud' },
  { label: 'Health and Safety', value: 'Health and Safety' },
  { label: 'Planned Maintenance Work', value: 'Planned Maintenance Work' },
  { label: 'Staff Conduct', value: 'Staff Conduct' },
  { label: 'Theft', value: 'Theft' },
  { label: 'Trespassing', value: 'Trespassing' },
  { label: 'Trouble accessing my email', value: 'Trouble accessing my email' },
  { label: 'Vehicle complaint', value: 'Vehicle complaint' },
  { label: 'Virgin Media Marketing', value: 'Virgin Media Marketing' },
  { label: '3rd Party complaint', value: '3rd Party complaint' },
  { label: 'Other', value: 'Other' },
];

const myContractPackageList = [
  {
    label: 'Having issues Upgrading/Downgrading',
    value: 'Having issues Upgrading/Downgrading',
  },
  { label: "I'm trying to Cancel", value: "I'm trying to Cancel" },
  {
    label: 'Missing my promotion/incentive',
    value: 'Missing my promotion/incentive',
  },
  {
    label: 'My contract price/length is incorrect',
    value: 'My contract price/length is incorrect',
  },
  {
    label: 'My personal details are incorrect',
    value: 'My personal details are incorrect',
  },
  {
    label: 'Unhappy with the offers available',
    value: 'Unhappy with the offers available',
  },
  { label: 'Other', value: 'Other' },
];

const privacyAndSecurityList = [
  { label: 'Agent error', value: 'Agent error' },
  { label: 'Child Access control', value: 'Child Access control' },
  { label: 'Compensation Amount', value: 'Compensation Amount' },
  {
    label: 'DPA - information given to unauthorised person',
    value: 'DPA - information given to unauthorised person',
  },
  {
    label: 'DPA failed - unable to complete',
    value: 'DPA failed - unable to complete',
  },
  { label: 'FCA Privacy and Security', value: 'FCA Privacy and Security' },
  { label: 'Fraud', value: 'Fraud' },
  {
    label: 'GDPR - Data protection issues',
    value: 'GDPR - Data protection issues',
  },
  {
    label: 'Misleading financial marketing/promotion about Refresh',
    value: 'Misleading financial marketing/promotion about Refresh',
  },
  { label: 'Nuisance Calls', value: 'Nuisance Calls' },
  { label: 'Staff Conduct', value: 'Staff Conduct' },
  { label: 'Unwanted emails', value: 'Unwanted emails' },
];

export const complaintsListMap = {
  'Activation/Provision': activationProvisionList,
  'Billing/Charges': billingChargesList,
  'Customer Experience': customerExperienceList,
  Faults: faultsList,
  "I'm not a customer": notCustomerList,
  'My Contract/Package': myContractPackageList,
  'Privacy and Security': privacyAndSecurityList,
};
